const attachmentParentType = {
  PAYMENT: 1,
  LORRY_RECEIPT: 2,
  INVOICE: 3,
  WALLET: 4,
  COMMENT: 5,
  WALLET_CONSIGNEE_DATA: 6,
  THIRD_PARTY_INVOICE: 7,
  DIGITALLY_SIGNED_INVOICE: 8,
  GATE_PASS: 9,
  E_INVOICE: 10,
};
const AttachmentConstants = {
  AttachableTypes: {
    DEFAULT: 1,
    ORDER: 2,
    OPTIMA: 3,
    EXPORT: 4,
  },
  ParentTypes: {
    SHIPPER: 1,
    TRANSPORTER: 2,
    CONSIGNEE: 3,
  },
};

module.exports = { attachmentParentType, AttachmentConstants };
